module.exports = __webpack_public_path__ + "static/media/default.18c5b89a.svg";